var exports = {
  "kL": "ReportFlowThankYou.module__container___ODJZUk",
  "rf": "ReportFlowThankYou.module__body___ODJZUk",
  "uW": "ReportFlowThankYou.module__section___ODJZUk",
  "R_": "ReportFlowThankYou.module__heading___ODJZUk",
  "aP": "ReportFlowThankYou.module__box___ODJZUk",
  "nM": "ReportFlowThankYou.module__row___ODJZUk",
  "qg": "ReportFlowThankYou.module__rowText___ODJZUk",
  "G9": "ReportFlowThankYou.module__rowTitle___ODJZUk",
  "Z$": "ReportFlowThankYou.module__rowDescription___ODJZUk",
};

module.exports = exports;
